import { render, staticRenderFns } from "./ContactSuggestor.vue?vue&type=template&id=d394f96e&"
import script from "./ContactSuggestor.vue?vue&type=script&lang=js&"
export * from "./ContactSuggestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports